"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleUIOptimisation = exports.getShowCustomVariable = exports.getIntentLink = exports.getHideCustomVariable = exports.getFormUrlLink = exports.STRING_VARIABLE_CONTAINER_CLASS = exports.RichText = exports.LINK_DATA_TYPE = exports.HIDE_CLASS = void 0;
exports.handleVariable = handleVariable;
exports.isIntentLink = exports.isFormUrlLink = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _dateFns = require("date-fns");
var _sanitizeHtmlOptions = _interopRequireDefault(require("../../constants/sanitizeHtmlOptions"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _tools = require("../../utils/tools");
var _context = require("../ConfigProvider/context");
var _context2 = require("../../components/ConfigProvider/context");
var _intersectionObserver = require("../../utils/intersectionObserver");
var _constants = require("../../utils/tracking/constants");
var _elementScrollTrack = require("../../utils/tracking/elementScrollTrack");
var _types = require("../../types");
var _Message = require("../Message");
var _expand = _interopRequireDefault(require("../../assets/images/expand.svg"));
var _LocaleProvider = require("../LocaleProvider");
var _handleUIOptimisation = require("./handleUIOptimisation");
var _excluded = ["operation", "trackingsection", "trackingtarget", "data"],
  _excluded2 = ["trackingsection"],
  _excluded3 = ["trackingsection"],
  _excluded4 = ["trackingsection"],
  _excluded5 = ["trackingsection"],
  _excluded6 = ["trackingsection"],
  _excluded7 = ["trackingsection"],
  _excluded8 = ["trackingsection"],
  _excluded9 = ["trackingsection"],
  _excluded10 = ["trackingsection"],
  _excluded11 = ["trackingsection"],
  _excluded12 = ["trackingsection"],
  _excluded13 = ["trackingsection"],
  _excluded14 = ["trackingsection"],
  _excluded15 = ["trackingsection"],
  _excluded16 = ["trackingsection"],
  _excluded17 = ["trackingsection"],
  _excluded18 = ["trackingsection"],
  _excluded19 = ["trackingsection"],
  _excluded20 = ["trackingsection"],
  _excluded21 = ["trackingsection"];
var _variableHandler;
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var REDIRECTION_BUTTON_TRIGGER_TYPE;
(function (REDIRECTION_BUTTON_TRIGGER_TYPE) {
  REDIRECTION_BUTTON_TRIGGER_TYPE["URL"] = "URL";
  REDIRECTION_BUTTON_TRIGGER_TYPE["TASK_BOT"] = "TASK_BOT";
  REDIRECTION_BUTTON_TRIGGER_TYPE["INTENT"] = "INTENT";
})(REDIRECTION_BUTTON_TRIGGER_TYPE || (REDIRECTION_BUTTON_TRIGGER_TYPE = {}));
var REGEXP_VARIABLE = /<a\s+href=\\?"variable:[^<]*>[^<]*<\/a>/g;
var REGEXP_DATE_FORMAT = /.*dateFormat=([^;\s"&;\?\\]*)/;
var DATE_VARIABLE_CONTAINER_CLASS = 'date-variable-container';
var STRING_VARIABLE_CONTAINER_CLASS = 'string-variable-container';
exports.STRING_VARIABLE_CONTAINER_CLASS = STRING_VARIABLE_CONTAINER_CLASS;
var HIDE_CLASS = 'hidden';
exports.HIDE_CLASS = HIDE_CLASS;
var imgCssSelector = 'img:not(.ChatbotUI-accordion-item-icon)';
var DATE_FORMATS = ['yyyy-MM-dd HH:mm:ss', 'yyyy-MM-DD HH:mm:ss', 'yyyy-MM-dd HH:mm', 'yyyy-MM-DD HH:mm', 'yyyy-MM-dd', 'yyyy-MM-DD', 'dd/MM/yyyy', 'dd/MM/yy', 'DD/MM/yyyy', 'DD/MM/yy', 'yyyy/M/d', 'yyyy/M/d H:mm:ss', 'yyyy:M:d H:mm:ss', 'd/M/yyyy H:mm:ss', 'd:M:yyyy H:mm:ss', 'yyyy:M:d', 'd/M/yyyy', 'd:M:yyyy', 'dd-MM-yyyy', 'DD-MM-yyyy', 'dd-MM-yyyy HH:mm', 'DD-MM-yyyy HH:mm', 'DD MMM'];
var variableFormaterType;
(function (variableFormaterType) {
  variableFormaterType["Date"] = "date";
  variableFormaterType["String"] = "string";
})(variableFormaterType || (variableFormaterType = {}));
var LINK_DATA_TYPE;
exports.LINK_DATA_TYPE = LINK_DATA_TYPE;
(function (LINK_DATA_TYPE) {
  LINK_DATA_TYPE["jumpNode"] = "jump-node";
  LINK_DATA_TYPE["jumpIntent"] = "jump-intent";
  LINK_DATA_TYPE["jumpOrderShortcut"] = "jump-order-shortcut";
})(LINK_DATA_TYPE || (exports.LINK_DATA_TYPE = LINK_DATA_TYPE = {}));
var variableHandler = (_variableHandler = {}, (0, _defineProperty2.default)(_variableHandler, variableFormaterType.Date, function (content) {
  var _ref = content.match(REGEXP_DATE_FORMAT) || [],
    _ref2 = (0, _slicedToArray2.default)(_ref, 2),
    dateFormat = _ref2[1];
  if (!dateFormat || !DATE_FORMATS.includes(decodeURIComponent(dateFormat.replaceAll('+', ' ')))) {
    return content;
  }
  var transformedDateFormat = (0, _tools.transformToDateFnsFormat)(decodeURIComponent(dateFormat.replaceAll('+', ' ')));
  var text = "".concat(content, "<span class=\"date-text ").concat(HIDE_CLASS, "\">").concat((0, _dateFns.format)(new Date(), transformedDateFormat), "</span>");
  return "<span class=\"".concat(DATE_VARIABLE_CONTAINER_CLASS, "\">").concat(text, "</span>");
}), (0, _defineProperty2.default)(_variableHandler, variableFormaterType.String, function (content, previewMockData) {
  var _previewMockData;
  previewMockData = (_previewMockData = previewMockData) !== null && _previewMockData !== void 0 ? _previewMockData : {};
  if (!previewMockData) {
    return content;
  }
  var variableList = content.match(/variable:([a-z|A-Z|0-9|\._]*)\?*/);
  if (!variableList || !(variableList !== null && variableList !== void 0 && variableList[1]) || !previewMockData[variableList === null || variableList === void 0 ? void 0 : variableList[1]]) {
    return content;
  }
  var text = "".concat(content, "<span class=\"date-text ").concat(HIDE_CLASS, "\">").concat(previewMockData[variableList === null || variableList === void 0 ? void 0 : variableList[1]], "</span>");
  return "<span class=\"".concat(STRING_VARIABLE_CONTAINER_CLASS, "\">").concat(text, "</span>");
}), _variableHandler);
var handleShowCustomVariable = function handleShowCustomVariable(item) {
  var _item$firstElementChi, _item$lastElementChil;
  (_item$firstElementChi = item.firstElementChild) === null || _item$firstElementChi === void 0 ? void 0 : _item$firstElementChi.classList.add(HIDE_CLASS);
  (_item$lastElementChil = item.lastElementChild) === null || _item$lastElementChil === void 0 ? void 0 : _item$lastElementChil.classList.remove(HIDE_CLASS);
};
var getShowCustomVariable = function getShowCustomVariable(ele) {
  return (0, _tools.debounce)(function () {
    if ('length' in ele) {
      ele.forEach(function (item) {
        return handleShowCustomVariable(item);
      });
    } else {
      handleShowCustomVariable(ele);
    }
  }, 50);
};
exports.getShowCustomVariable = getShowCustomVariable;
var handleHideCustomVariable = function handleHideCustomVariable(item) {
  var _item$firstElementChi2, _item$lastElementChil2;
  (_item$firstElementChi2 = item.firstElementChild) === null || _item$firstElementChi2 === void 0 ? void 0 : _item$firstElementChi2.classList.remove(HIDE_CLASS);
  (_item$lastElementChil2 = item.lastElementChild) === null || _item$lastElementChil2 === void 0 ? void 0 : _item$lastElementChil2.classList.add(HIDE_CLASS);
};
var getHideCustomVariable = function getHideCustomVariable(ele) {
  return (0, _tools.debounce)(function () {
    if ('length' in ele) {
      ele.forEach(function (item) {
        return handleHideCustomVariable(item);
      });
    } else {
      handleHideCustomVariable(ele);
    }
  }, 50);
}; // const checkVariableTypeIsDate = (html: string) => {
//   // 判断 variable type 是不是 date 类型
//   const [, dateFormat] = html.match(REGEXP_DATE_FORMAT) || [];
//   return !(!dateFormat || !DATE_FORMATS.includes(decodeURIComponent(dateFormat.replaceAll('+', ' '))));
// };

exports.getHideCustomVariable = getHideCustomVariable;
function handleVariable(content, _ref3) {
  var shouldHandleDateVariable = _ref3.shouldHandleDateVariable,
    previewMockData = _ref3.previewMockData;
  if (!shouldHandleDateVariable) {
    return content;
  }
  var newText = content.replace(REGEXP_VARIABLE, function (matchText) {
    // 目前进行改造 不需要 date 类型 都走 字符串替换类型
    return variableHandler[variableFormaterType.String](matchText, previewMockData); // if (checkVariableTypeIsDate(matchText)) {
    //   return variableHandler[variableFormaterType.Date](matchText);
    // } else {
    //   // 添加新的类型 字符串替换 目前 除了 date 其余都是这种类型
    //   return variableHandler[variableFormaterType.String](matchText, previewMockData);
    // }
  });

  return newText;
}
var getJumpLinkData = function getJumpLinkData(url) {
  var _url$split;
  if (!url) {
    return {};
  }
  var customDataString = (url === null || url === void 0 ? void 0 : (_url$split = url.split('custom-data:')) === null || _url$split === void 0 ? void 0 : _url$split[1]) || '';
  var _decodeChatbotTextDat = (0, _tools.decodeChatbotTextData)(customDataString),
    dataType = _decodeChatbotTextDat['data-type'],
    jumpKey = _decodeChatbotTextDat['jump-key'];
  return {
    dataType: dataType,
    jumpKey: jumpKey
  };
};
var generateClickTrackingData = function generateClickTrackingData(trackingsection, trackingtarget, data) {
  return {
    trackingsection: trackingsection,
    trackingtarget: trackingtarget,
    data: data
  };
};
var generateImpressionTrackingData = function generateImpressionTrackingData(trackingsection, trackingtarget, data) {
  return {
    trackingsection: trackingsection,
    trackingtarget: trackingtarget,
    trackingdata: JSON.stringify(data)
  };
};
var handleTrackerClick = function handleTrackerClick(_ref4) {
  var _dataMaintainer$track, _dataMaintainer$track2;
  var _ref4$operation = _ref4.operation,
    operation = _ref4$operation === void 0 ? _constants.TRACKING_OPERATION.CLICK : _ref4$operation,
    trackingsection = _ref4.trackingsection,
    trackingtarget = _ref4.trackingtarget,
    data = _ref4.data,
    rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  (_dataMaintainer$track = _context2.dataMaintainer.tracker) === null || _dataMaintainer$track === void 0 ? void 0 : (_dataMaintainer$track2 = _dataMaintainer$track.dispatchTrack) === null || _dataMaintainer$track2 === void 0 ? void 0 : _dataMaintainer$track2.call(_dataMaintainer$track, _objectSpread({
    operation: operation,
    section: trackingsection,
    target: trackingtarget,
    data: data
  }, rest));
};
var handleTrackImpression = function handleTrackImpression(ele, data) {
  var random = Math.random() + '';
  ele.dataset.trackingkey = random;
  _context2.dataMaintainer.addTrackerMap(random, data);
  (0, _intersectionObserver.addObserver)(ele);
};
var removeTrackImpression = function removeTrackImpression(ele) {
  var random = ele.dataset.trackingkey;
  random && _context2.dataMaintainer.deleteTrackerMap(random);
  (0, _intersectionObserver.removeObserver)(ele);
};
var getAppLink = function getAppLink(link) {
  // 是否返回的是 rn 或 native 链接
  var regx = /^in-app:(r?n)\/(\S+)$/;
  var splitInAppLink = regx.exec(link);
  return splitInAppLink;
};
var isInAppLink = function isInAppLink(link) {
  return getAppLink(link) != null;
};
var getHyperlinkType = function getHyperlinkType(element) {
  var _element$href;
  var href = (_element$href = element === null || element === void 0 ? void 0 : element.href) !== null && _element$href !== void 0 ? _element$href : '';
  if (isInAppLink(href)) {
    return _constants.ARTICLE_DETAIL_HYPERLINK_TYPE.IN_APP;
  } else if (isIntentLink(href)) {
    return _constants.ARTICLE_DETAIL_HYPERLINK_TYPE.INTENT;
  } else if (isFormUrlLink(href)) {
    return _constants.ARTICLE_DETAIL_HYPERLINK_TYPE.FORM_URL;
  } else if (href.startsWith('https')) {
    return _constants.ARTICLE_DETAIL_HYPERLINK_TYPE.HTTPS;
  } else {
    return _constants.ARTICLE_DETAIL_HYPERLINK_TYPE.HTTP;
  }
};
var isIntentLink = function isIntentLink(link) {
  return getIntentLink(link) != null;
};
exports.isIntentLink = isIntentLink;
var getIntentLink = function getIntentLink() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var regx = /^intent:/;
  var result = regx.exec(link);
  if (result === null) {
    return result;
  } else {
    return link.replace(regx, '');
  }
};
exports.getIntentLink = getIntentLink;
var isFormUrlLink = function isFormUrlLink(link) {
  return getFormUrlLink(link) != null;
};
exports.isFormUrlLink = isFormUrlLink;
var getFormUrlLink = function getFormUrlLink() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var regx = /^form-url:/;
  var result = regx.exec(link);
  if (result === null) {
    return result;
  } else {
    return link.replace(regx, '');
  }
};
exports.getFormUrlLink = getFormUrlLink;
var handleUIOptimisation = function handleUIOptimisation(options) {
  var _ref5 = options || {},
    _ref5$html = _ref5.html,
    html = _ref5$html === void 0 ? '' : _ref5$html,
    _ref5$isUIOptimisatio = _ref5.isUIOptimisationAccordion,
    isUIOptimisationAccordion = _ref5$isUIOptimisatio === void 0 ? false : _ref5$isUIOptimisatio,
    _ref5$expand = _ref5.expand,
    expand = _ref5$expand === void 0 ? false : _ref5$expand,
    _ref5$accordionItemIn = _ref5.accordionItemIndex,
    accordionItemIndex = _ref5$accordionItemIn === void 0 ? -1 : _ref5$accordionItemIn,
    _ref5$accordionIndex = _ref5.accordionIndex,
    accordionIndex = _ref5$accordionIndex === void 0 ? -1 : _ref5$accordionIndex;
  if (!isUIOptimisationAccordion) {
    return html;
  }
  var container = document.createElement('div');
  container.innerHTML = html;
  var accordionBLockList = container.querySelectorAll('accordion-block');
  accordionBLockList.forEach(function (item, idx) {
    if (isUIOptimisationAccordion) {
      item.setAttribute('is-ui-optimisation-accordion', 'true');
      if (accordionIndex === idx) {
        var _accordionItemIndex$t;
        item.setAttribute('default-select-index', accordionItemIndex === null || accordionItemIndex === void 0 ? void 0 : (_accordionItemIndex$t = accordionItemIndex.toString) === null || _accordionItemIndex$t === void 0 ? void 0 : _accordionItemIndex$t.call(accordionItemIndex));
      }
      if (expand) {
        item.setAttribute('expand', 'true');
      } else {
        item.setAttribute('expand', 'false');
      }
    } else {
      item.setAttribute('is-ui-optimisation-accordion', 'false');
    }
  });
  return container.innerHTML;
};
exports.handleUIOptimisation = handleUIOptimisation;
var RichText = function RichText(props) {
  var _variableMouseOverLis, _variableMouseOutList, _clsx;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var className = props.className,
    content = props.content,
    _props$options = props.options,
    options = _props$options === void 0 ? _sanitizeHtmlOptions.default : _props$options,
    _props$shouldHandleDa = props.shouldHandleDateVariable,
    shouldHandleDateVariable = _props$shouldHandleDa === void 0 ? false : _props$shouldHandleDa,
    articleContentTrackingData = props.articleContentTrackingData,
    richTextMsgTrackingData = props.richTextMsgTrackingData,
    changeTrackCloseArticleContentData = props.changeTrackCloseArticleContentData,
    _props$disableSpecial = props.disableSpecialLink,
    disableSpecialLink = _props$disableSpecial === void 0 ? false : _props$disableSpecial,
    onClose = props.onClose,
    jumpNodeMap = props.jumpNodeMap,
    _props$jumpOrderShort = props.jumpOrderShortCutMap,
    jumpOrderShortCutMap = _props$jumpOrderShort === void 0 ? {} : _props$jumpOrderShort,
    _props$msgType = props.msgType,
    msgType = _props$msgType === void 0 ? _Message.MsgType.default : _props$msgType,
    _props$linkTrackingDa = props.linkTrackingData,
    linkTrackingData = _props$linkTrackingDa === void 0 ? {} : _props$linkTrackingDa,
    showExpandIcon = props.showExpandIcon,
    previewMockData = props.previewMockData,
    handleVariableShow = props.handleVariableShow,
    handleVariableHide = props.handleVariableHide,
    uiOptimisationAccordionOptions = props.uiOptimisationAccordionOptions,
    isUIOptimisationButton = props.isUIOptimisationButton,
    isUIOptimisationTableModal = props.isUIOptimisationTableModal,
    isUIOptimisationTableReview = props.isUIOptimisationTableReview,
    _props$isUIOptimisati = props.isUIOptimisationTableRichtext,
    isUIOptimisationTableRichtext = _props$isUIOptimisati === void 0 ? false : _props$isUIOptimisati;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    region = _useLocale.region;
  var tempContent = handleVariable(content, {
    shouldHandleDateVariable: shouldHandleDateVariable,
    previewMockData: previewMockData
  });
  var processedContent = (0, _react.useMemo)(function () {
    var resultHtml = (0, _tools.formatHtml)((0, _sanitizeHtml.default)(tempContent, options));
    if (uiOptimisationAccordionOptions) {
      resultHtml = handleUIOptimisation(_objectSpread(_objectSpread({}, uiOptimisationAccordionOptions), {}, {
        html: resultHtml
      }));
    }
    if (isUIOptimisationTableModal) {
      resultHtml = (0, _handleUIOptimisation.handleUIOptimisationTable)(resultHtml, {
        isRichtext: isUIOptimisationTableRichtext
      });
    } else if (isUIOptimisationTableReview) {
      resultHtml = (0, _handleUIOptimisation.handleUIOptimisationTableReview)(resultHtml);
    }
    return resultHtml;
  }, [tempContent, uiOptimisationAccordionOptions]);
  var html = (0, _react.useMemo)(
  // () => ({ __html: formatHtml(sanitizeHtml(processedContent, options)) }),
  // 把 sanitizeHtml 的处理逻辑提前
  function () {
    return {
      __html: processedContent
    };
  }, [processedContent, options]);
  var ref = (0, _react.useRef)(null);
  var variableMouseOverListners = (_variableMouseOverLis = {}, (0, _defineProperty2.default)(_variableMouseOverLis, variableFormaterType.Date, []), (0, _defineProperty2.default)(_variableMouseOverLis, variableFormaterType.String, []), _variableMouseOverLis);
  var variableMouseOutListners = (_variableMouseOutList = {}, (0, _defineProperty2.default)(_variableMouseOutList, variableFormaterType.Date, []), (0, _defineProperty2.default)(_variableMouseOutList, variableFormaterType.String, []), _variableMouseOutList);
  var elementScrollTrackManage = new _elementScrollTrack.ElementScrollTrackManage();
  var articleScrollsRef = (0, _react.useRef)(0);
  var tableScrollsRef = (0, _react.useRef)(0);
  var onClickEvent = function onClickEvent(e) {
    var _e$currentTarget, _e$currentTarget2, _url$split2;
    var href = e === null || e === void 0 ? void 0 : (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.getAttribute('href');
    var url = /^(in-app:)?(r?n)\/(\S+)/.test(href) ? href : e === null || e === void 0 ? void 0 : (_e$currentTarget2 = e.currentTarget) === null || _e$currentTarget2 === void 0 ? void 0 : _e$currentTarget2.href;
    var whitelist = ['tel:', 'mailto:'];
    var isUrlStartsWithWhitelist = whitelist.some(function (item) {
      return url === null || url === void 0 ? void 0 : url.startsWith(item);
    });
    var customDataString = (url === null || url === void 0 ? void 0 : (_url$split2 = url.split('custom-data:')) === null || _url$split2 === void 0 ? void 0 : _url$split2[1]) || '';
    var _decodeChatbotTextDat2 = (0, _tools.decodeChatbotTextData)(customDataString),
      dataType = _decodeChatbotTextDat2['data-type'],
      jumpKey = _decodeChatbotTextDat2['jump-key'];
    trackClickLinkEvent(e);
    if (isUrlStartsWithWhitelist) {
      if (url !== null && url !== void 0 && url.startsWith(whitelist[0])) {
        var _e$preventDefault;
        e === null || e === void 0 ? void 0 : (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 ? void 0 : _e$preventDefault.call(e);
        window.location.href = url.split('?')[0];
      }
      return;
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (dataType === LINK_DATA_TYPE.jumpNode) {
      var _context$eventEmitter, _context$eventEmitter2, _e$currentTarget3;
      if (disableSpecialLink) {
        return;
      }
      var jumpNodeParams = (jumpNodeMap === null || jumpNodeMap === void 0 ? void 0 : jumpNodeMap[jumpKey]) || {};
      context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, 'next', {
        text: (e === null || e === void 0 ? void 0 : (_e$currentTarget3 = e.currentTarget) === null || _e$currentTarget3 === void 0 ? void 0 : _e$currentTarget3.textContent) || '',
        action: jumpNodeParams
      });
      return;
    }
    if (dataType === LINK_DATA_TYPE.jumpOrderShortcut) {
      var _context$eventEmitter3, _context$eventEmitter4, _e$currentTarget4;
      if (disableSpecialLink) {
        return;
      }
      context === null || context === void 0 ? void 0 : (_context$eventEmitter3 = context.eventEmitter) === null || _context$eventEmitter3 === void 0 ? void 0 : (_context$eventEmitter4 = _context$eventEmitter3.emit) === null || _context$eventEmitter4 === void 0 ? void 0 : _context$eventEmitter4.call(_context$eventEmitter3, 'next', {
        text: (e === null || e === void 0 ? void 0 : (_e$currentTarget4 = e.currentTarget) === null || _e$currentTarget4 === void 0 ? void 0 : _e$currentTarget4.textContent) || '',
        action: jumpOrderShortCutMap
      });
      return;
    }
    if (dataType === LINK_DATA_TYPE.jumpIntent) {
      if (disableSpecialLink) {
        return;
      }
      try {
        var _e$currentTarget5, _e$currentTarget5$dat, _context$eventEmitter5, _context$eventEmitter6, _e$currentTarget6;

        // @ts-ignore
        var params = JSON.parse((e === null || e === void 0 ? void 0 : (_e$currentTarget5 = e.currentTarget) === null || _e$currentTarget5 === void 0 ? void 0 : (_e$currentTarget5$dat = _e$currentTarget5.dataset) === null || _e$currentTarget5$dat === void 0 ? void 0 : _e$currentTarget5$dat.params) || '');
        var jumpIntentParams = params || {};
        context === null || context === void 0 ? void 0 : (_context$eventEmitter5 = context.eventEmitter) === null || _context$eventEmitter5 === void 0 ? void 0 : (_context$eventEmitter6 = _context$eventEmitter5.emit) === null || _context$eventEmitter6 === void 0 ? void 0 : _context$eventEmitter6.call(_context$eventEmitter5, 'getIntent', {
          text: (e === null || e === void 0 ? void 0 : (_e$currentTarget6 = e.currentTarget) === null || _e$currentTarget6 === void 0 ? void 0 : _e$currentTarget6.textContent) || '',
          action: jumpIntentParams
        });
      } catch (e) {
        console.log(e);
      }
      return;
    }
    if (url) {
      if (isIntentLink(url)) {
        var _context$eventEmitter7, _context$eventEmitter8, _target;
        context === null || context === void 0 ? void 0 : (_context$eventEmitter7 = context.eventEmitter) === null || _context$eventEmitter7 === void 0 ? void 0 : (_context$eventEmitter8 = _context$eventEmitter7.emit) === null || _context$eventEmitter8 === void 0 ? void 0 : _context$eventEmitter8.call(_context$eventEmitter7, _types.ButtonEvents.ClickArticleRedirectionButton, {
          buttonName: e === null || e === void 0 ? void 0 : (_target = e.target) === null || _target === void 0 ? void 0 : _target.innerText,
          dialogueId: (articleContentTrackingData === null || articleContentTrackingData === void 0 ? void 0 : articleContentTrackingData.chat_dialogue_id) || (richTextMsgTrackingData === null || richTextMsgTrackingData === void 0 ? void 0 : richTextMsgTrackingData.chat_dialogue_id),
          intentId: getIntentLink(url),
          triggerType: REDIRECTION_BUTTON_TRIGGER_TYPE.INTENT
        });
        onClose === null || onClose === void 0 ? void 0 : onClose();
      } else if (isFormUrlLink(url)) {
        var _context$eventEmitter9, _context$eventEmitter10;
        context === null || context === void 0 ? void 0 : (_context$eventEmitter9 = context.eventEmitter) === null || _context$eventEmitter9 === void 0 ? void 0 : (_context$eventEmitter10 = _context$eventEmitter9.emit) === null || _context$eventEmitter10 === void 0 ? void 0 : _context$eventEmitter10.call(_context$eventEmitter9, _types.ButtonEvents.Redirection, {
          text: '',
          action: {
            url_info: {
              url: getFormUrlLink(url)
            },
            onClose: onClose
          }
        });
      } else {
        var _context$eventEmitter11, _context$eventEmitter12;
        context === null || context === void 0 ? void 0 : (_context$eventEmitter11 = context.eventEmitter) === null || _context$eventEmitter11 === void 0 ? void 0 : (_context$eventEmitter12 = _context$eventEmitter11.emit) === null || _context$eventEmitter12 === void 0 ? void 0 : _context$eventEmitter12.call(_context$eventEmitter11, _types.ButtonEvents.Redirection, {
          text: '',
          action: {
            url_info: {
              url: url
            },
            onClose: onClose
          }
        });
      }
    }
  };
  var onImageClickEvent = function onImageClickEvent(e) {
    var _e$currentTarget7;
    var url = e === null || e === void 0 ? void 0 : (_e$currentTarget7 = e.currentTarget) === null || _e$currentTarget7 === void 0 ? void 0 : _e$currentTarget7.src;
    if (articleContentTrackingData) {
      var trackingsection = articleContentTrackingData.trackingsection,
        restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded2);
      var data = generateClickTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.imageOrGif, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
        content: url || ''
      }));
      handleTrackerClick(data);
    }
    if (richTextMsgTrackingData) {
      var _trackingsection = richTextMsgTrackingData.trackingsection,
        _restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded3);
      var _data = generateClickTrackingData(_trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.imageOrGif, _objectSpread(_objectSpread({}, _restArticleContentTrackingData), {}, {
        content: url || ''
      }));
      handleTrackerClick(_data);
    }
    if (url) {
      var _context$eventEmitter13, _context$eventEmitter14;
      context === null || context === void 0 ? void 0 : (_context$eventEmitter13 = context.eventEmitter) === null || _context$eventEmitter13 === void 0 ? void 0 : (_context$eventEmitter14 = _context$eventEmitter13.emit) === null || _context$eventEmitter14 === void 0 ? void 0 : _context$eventEmitter14.call(_context$eventEmitter13, _types.UIEvents.PreviewImage, {
        url: url
      });
    }
  };
  var updateArticleScrolls = function updateArticleScrolls() {
    var articleScrolls = articleScrollsRef.current + 1;
    articleScrollsRef.current = articleScrolls;
    changeTrackCloseArticleContentData === null || changeTrackCloseArticleContentData === void 0 ? void 0 : changeTrackCloseArticleContentData({
      articleScrolls: articleScrolls
    });
  };
  var updateTableScrolls = function updateTableScrolls() {
    var tableScrolls = tableScrollsRef.current + 1;
    tableScrollsRef.current = tableScrolls;
    changeTrackCloseArticleContentData === null || changeTrackCloseArticleContentData === void 0 ? void 0 : changeTrackCloseArticleContentData({
      tableScrolls: tableScrolls
    });
  };
  var onAccordionClick = function onAccordionClick(e, accordionIndex) {
    var _e$target;
    var clickedAccordionItem = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.closest('.ChatbotUI-accordion-item');
    if (clickedAccordionItem !== null) {
      var _clickedAccordionItem, _uiOptimisationAccord;
      var accordionItems = Array.from((clickedAccordionItem === null || clickedAccordionItem === void 0 ? void 0 : (_clickedAccordionItem = clickedAccordionItem.parentElement) === null || _clickedAccordionItem === void 0 ? void 0 : _clickedAccordionItem.children) || []);
      var clickedIndex = accordionItems.indexOf(clickedAccordionItem); // @ts-ignore

      var clickedTitle = clickedAccordionItem === null || clickedAccordionItem === void 0 ? void 0 : clickedAccordionItem.querySelector('.title').textContent;
      if (articleContentTrackingData) {
        var trackingsection = articleContentTrackingData.trackingsection,
          restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded4);
        var data = generateClickTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.accordionCardTitle, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
          content: clickedTitle || '',
          location: clickedIndex || 0
        }));
        handleTrackerClick(data);
      }
      if (richTextMsgTrackingData) {
        var _trackingsection2 = richTextMsgTrackingData.trackingsection,
          _restArticleContentTrackingData2 = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded5);
        var _data2 = generateClickTrackingData(_trackingsection2 || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.accordionCardTitle, _objectSpread(_objectSpread({}, _restArticleContentTrackingData2), {}, {
          content: clickedTitle || '',
          location: clickedIndex || 0
        }));
        handleTrackerClick(_data2);
      }
      uiOptimisationAccordionOptions === null || uiOptimisationAccordionOptions === void 0 ? void 0 : (_uiOptimisationAccord = uiOptimisationAccordionOptions.onUIOptimisationAccordionClick) === null || _uiOptimisationAccord === void 0 ? void 0 : _uiOptimisationAccord.call(uiOptimisationAccordionOptions, clickedIndex, accordionIndex);
    }
  };
  var onRedirectionButtonClick = function onRedirectionButtonClick(e) {
    var _context$eventEmitter15, _context$eventEmitter16;
    var ele = e.currentTarget;
    var buttonData;
    try {
      var _ele$dataset;
      buttonData = JSON.parse((ele === null || ele === void 0 ? void 0 : (_ele$dataset = ele.dataset) === null || _ele$dataset === void 0 ? void 0 : _ele$dataset.buttonJson) || '');
    } catch (_unused) {}
    if (articleContentTrackingData) {
      var _buttonData, _buttonData2, _buttonData3;
      var trackingsection = articleContentTrackingData.trackingsection,
        restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded6);
      var data = generateClickTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.redirectionButton, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
        content: ele.textContent || '',
        trigger_type: (_buttonData = buttonData) === null || _buttonData === void 0 ? void 0 : _buttonData.triggerType,
        target_intent_id: (_buttonData2 = buttonData) === null || _buttonData2 === void 0 ? void 0 : _buttonData2.intentId,
        target_taskbot_id: (_buttonData3 = buttonData) === null || _buttonData3 === void 0 ? void 0 : _buttonData3.taskBotId
      }));
      handleTrackerClick(data);
    }
    if (richTextMsgTrackingData) {
      var _trackingsection3 = richTextMsgTrackingData.trackingsection,
        _restArticleContentTrackingData3 = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded7);
      var _data3 = generateClickTrackingData(_trackingsection3 || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.redirectionButton, _objectSpread(_objectSpread({}, _restArticleContentTrackingData3), {}, {
        content: ele.textContent || ''
      }));
      handleTrackerClick(_data3);
    }
    buttonData && (context === null || context === void 0 ? void 0 : (_context$eventEmitter15 = context.eventEmitter) === null || _context$eventEmitter15 === void 0 ? void 0 : (_context$eventEmitter16 = _context$eventEmitter15.emit) === null || _context$eventEmitter16 === void 0 ? void 0 : _context$eventEmitter16.call(_context$eventEmitter15, _types.ButtonEvents.ClickArticleRedirectionButton, _objectSpread(_objectSpread({}, buttonData), {}, {
      dialogueId: (articleContentTrackingData === null || articleContentTrackingData === void 0 ? void 0 : articleContentTrackingData.chat_dialogue_id) || (richTextMsgTrackingData === null || richTextMsgTrackingData === void 0 ? void 0 : richTextMsgTrackingData.chat_dialogue_id),
      disableClick: disableSpecialLink,
      onClose: onClose
    }))) && !disableSpecialLink && (buttonData.triggerType === REDIRECTION_BUTTON_TRIGGER_TYPE.TASK_BOT || buttonData.triggerType === REDIRECTION_BUTTON_TRIGGER_TYPE.INTENT) && (onClose === null || onClose === void 0 ? void 0 : onClose());
  };
  var handleAddEventListener = function handleAddEventListener() {
    var _ref$current, _ref$current$querySel, _ref$current2, _ref$current2$querySe, _ref$current3, _ref$current3$querySe, _ref$current4, _ref$current5, _ref$current6, _ref$current6$querySe, _ref$current7, _ref$current7$querySe, _ref$current8, _ref$current8$querySe;
    ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$querySel = _ref$current.querySelectorAll('a')) === null || _ref$current$querySel === void 0 ? void 0 : _ref$current$querySel.forEach(function (ele) {
      trackLinkImpressionEvent(ele);
      ele.addEventListener('click', onClickEvent);
    });
    ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : (_ref$current2$querySe = _ref$current2.querySelectorAll('iframe')) === null || _ref$current2$querySe === void 0 ? void 0 : _ref$current2$querySe.forEach(function (ele) {
      if (articleContentTrackingData) {
        var trackingsection = articleContentTrackingData.trackingsection,
          restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded8);
        var impressionTrackingData = generateImpressionTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.video, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
          content: ele.src || ''
        }));
        handleTrackImpression(ele, impressionTrackingData);
      }
      if (richTextMsgTrackingData) {
        var _trackingsection4 = richTextMsgTrackingData.trackingsection,
          _restArticleContentTrackingData4 = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded9);
        var _impressionTrackingData = generateImpressionTrackingData(_trackingsection4 || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.video, _objectSpread(_objectSpread({}, _restArticleContentTrackingData4), {}, {
          content: ele.src || ''
        }));
        handleTrackImpression(ele, _impressionTrackingData);
      } // ele.addEventListener('click', onImageClickEvent);
    });

    ref === null || ref === void 0 ? void 0 : (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : (_ref$current3$querySe = _ref$current3.querySelectorAll(imgCssSelector)) === null || _ref$current3$querySe === void 0 ? void 0 : _ref$current3$querySe.forEach(function (ele) {
      if (articleContentTrackingData) {
        var trackingsection = articleContentTrackingData.trackingsection,
          restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded10);
        var impressionTrackingData = generateImpressionTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.imageOrGif, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
          content: ele.src || ''
        }));
        handleTrackImpression(ele, impressionTrackingData);
      }
      if (richTextMsgTrackingData) {
        var _trackingsection5 = richTextMsgTrackingData.trackingsection,
          _restArticleContentTrackingData5 = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded11);
        var _impressionTrackingData2 = generateImpressionTrackingData(_trackingsection5 || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.imageOrGif, _objectSpread(_objectSpread({}, _restArticleContentTrackingData5), {}, {
          content: ele.src || ''
        }));
        handleTrackImpression(ele, _impressionTrackingData2);
      }
      ele.addEventListener('click', onImageClickEvent);
    }); // 根据 tfe 1.9.9 的需求 当 hover 其中一个变量时 所有变量都会变化

    var dateVariableContainerDom = ref === null || ref === void 0 ? void 0 : (_ref$current4 = ref.current) === null || _ref$current4 === void 0 ? void 0 : _ref$current4.querySelectorAll(".".concat(DATE_VARIABLE_CONTAINER_CLASS));
    dateVariableContainerDom === null || dateVariableContainerDom === void 0 ? void 0 : dateVariableContainerDom.forEach(function (ele, index) {
      var _ele$firstElementChil, _ele$lastElementChild;
      variableMouseOverListners[variableFormaterType.Date][index] = handleVariableShow ? handleVariableShow : getShowCustomVariable(dateVariableContainerDom);
      variableMouseOutListners[variableFormaterType.Date][index] = handleVariableHide ? handleVariableHide : getHideCustomVariable(dateVariableContainerDom);
      (_ele$firstElementChil = ele.firstElementChild) === null || _ele$firstElementChil === void 0 ? void 0 : _ele$firstElementChil.addEventListener('mouseover', variableMouseOverListners[variableFormaterType.Date][index]);
      (_ele$lastElementChild = ele.lastElementChild) === null || _ele$lastElementChild === void 0 ? void 0 : _ele$lastElementChild.addEventListener('mouseout', variableMouseOutListners[variableFormaterType.Date][index]);
    });
    var stringVariableContainerDom = ref === null || ref === void 0 ? void 0 : (_ref$current5 = ref.current) === null || _ref$current5 === void 0 ? void 0 : _ref$current5.querySelectorAll(".".concat(STRING_VARIABLE_CONTAINER_CLASS));
    stringVariableContainerDom === null || stringVariableContainerDom === void 0 ? void 0 : stringVariableContainerDom.forEach(function (ele, index) {
      var _ele$firstElementChil2, _ele$lastElementChild2;
      variableMouseOverListners[variableFormaterType.String][index] = handleVariableShow ? handleVariableShow : getShowCustomVariable(stringVariableContainerDom);
      variableMouseOutListners[variableFormaterType.String][index] = handleVariableHide ? handleVariableHide : getHideCustomVariable(stringVariableContainerDom);
      (_ele$firstElementChil2 = ele.firstElementChild) === null || _ele$firstElementChil2 === void 0 ? void 0 : _ele$firstElementChil2.addEventListener('mouseover', variableMouseOverListners[variableFormaterType.String][index]);
      (_ele$lastElementChild2 = ele.lastElementChild) === null || _ele$lastElementChild2 === void 0 ? void 0 : _ele$lastElementChild2.addEventListener('mouseout', variableMouseOutListners[variableFormaterType.String][index]);
    });
    ref === null || ref === void 0 ? void 0 : (_ref$current6 = ref.current) === null || _ref$current6 === void 0 ? void 0 : (_ref$current6$querySe = _ref$current6.querySelectorAll('.redirection-button-to-taskbots-or-app-page')) === null || _ref$current6$querySe === void 0 ? void 0 : _ref$current6$querySe.forEach(function (ele) {
      if (articleContentTrackingData) {
        var _buttonData4, _buttonData5, _buttonData6;
        var trackingsection = articleContentTrackingData.trackingsection,
          restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded12);
        var buttonData;
        try {
          var _ele$dataset2;
          buttonData = JSON.parse((ele === null || ele === void 0 ? void 0 : (_ele$dataset2 = ele.dataset) === null || _ele$dataset2 === void 0 ? void 0 : _ele$dataset2.buttonJson) || '');
        } catch (_unused2) {}
        var impressionTrackingData = generateImpressionTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.redirectionButton, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
          content: ele.textContent || '',
          trigger_type: (_buttonData4 = buttonData) === null || _buttonData4 === void 0 ? void 0 : _buttonData4.triggerType,
          target_intent_id: (_buttonData5 = buttonData) === null || _buttonData5 === void 0 ? void 0 : _buttonData5.intentId,
          target_taskbot_id: (_buttonData6 = buttonData) === null || _buttonData6 === void 0 ? void 0 : _buttonData6.taskBotId
        }));
        handleTrackImpression(ele, impressionTrackingData);
      }
      if (richTextMsgTrackingData) {
        var _trackingsection6 = richTextMsgTrackingData.trackingsection,
          _restArticleContentTrackingData6 = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded13);
        var _impressionTrackingData3 = generateImpressionTrackingData(_trackingsection6 || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.redirectionButton, _objectSpread(_objectSpread({}, _restArticleContentTrackingData6), {}, {
          content: ele.textContent || ''
        }));
        handleTrackImpression(ele, _impressionTrackingData3);
      }
      ele.addEventListener('click', onRedirectionButtonClick);
    });
    ref === null || ref === void 0 ? void 0 : (_ref$current7 = ref.current) === null || _ref$current7 === void 0 ? void 0 : (_ref$current7$querySe = _ref$current7.querySelectorAll('accordion-block')) === null || _ref$current7$querySe === void 0 ? void 0 : _ref$current7$querySe.forEach(function (ele, accordionIndex) {
      if (articleContentTrackingData) {
        var tileElements = ele.querySelectorAll('.title');
        var textContents = Array.from(tileElements).map(function (element) {
          return element.textContent;
        });
        var trackingsection = articleContentTrackingData.trackingsection,
          restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded14);
        var impressionTrackingData = generateImpressionTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.accordionCardTitle, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
          content: textContents.join(',') || ''
        }));
        handleTrackImpression(ele, impressionTrackingData);
      }
      if (richTextMsgTrackingData) {
        var _tileElements = ele.querySelectorAll('.title');
        var _textContents = Array.from(_tileElements).map(function (element) {
          return element.textContent;
        });
        var _trackingsection7 = richTextMsgTrackingData.trackingsection,
          _restArticleContentTrackingData7 = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded15);
        var _impressionTrackingData4 = generateImpressionTrackingData(_trackingsection7 || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.accordionCardTitle, _objectSpread(_objectSpread({}, _restArticleContentTrackingData7), {}, {
          content: _textContents.join(',') || ''
        }));
        handleTrackImpression(ele, _impressionTrackingData4);
      }
      ele.addEventListener('click', function (e) {
        onAccordionClick(e, accordionIndex);
      });
    });
    ref === null || ref === void 0 ? void 0 : (_ref$current8 = ref.current) === null || _ref$current8 === void 0 ? void 0 : (_ref$current8$querySe = _ref$current8.querySelectorAll('table')) === null || _ref$current8$querySe === void 0 ? void 0 : _ref$current8$querySe.forEach(function (ele) {
      var _ele$querySelectorAll;
      if (articleContentTrackingData) {
        elementScrollTrackManage.addTrack(ele, _elementScrollTrack.ScrollType.Vertical, {
          scrollCallback: updateTableScrolls
        });
        var trackingsection = articleContentTrackingData.trackingsection,
          restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded16);
        var impressionTrackingData = generateImpressionTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.table, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
          content: ele.innerHTML || ''
        }));
        handleTrackImpression(ele, impressionTrackingData);
      }
      if (richTextMsgTrackingData) {
        elementScrollTrackManage.addTrack(ele, _elementScrollTrack.ScrollType.Vertical, {
          scrollCallback: updateTableScrolls
        });
        var _trackingsection8 = richTextMsgTrackingData.trackingsection,
          _restArticleContentTrackingData8 = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded17);
        var _impressionTrackingData5 = generateImpressionTrackingData(_trackingsection8 || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.table, _objectSpread(_objectSpread({}, _restArticleContentTrackingData8), {}, {
          content: ele.innerHTML || ''
        }));
        handleTrackImpression(ele, _impressionTrackingData5);
      }
      (_ele$querySelectorAll = ele.querySelectorAll('a')) === null || _ele$querySelectorAll === void 0 ? void 0 : _ele$querySelectorAll.forEach(function (hyperlink) {
        var parentElement = hyperlink.parentElement;
        var wrapper = document.createElement('div');
        wrapper.classList.add('table-hyperlink-wrapper');
        parentElement === null || parentElement === void 0 ? void 0 : parentElement.replaceChild(wrapper, hyperlink);
        wrapper.appendChild(hyperlink);
      });
      var articleWidth = ref.current.clientWidth;
      var tableWidth = parseInt(ele.style.width);
      if (articleWidth < tableWidth) {
        var colGroup = ele.querySelectorAll('col');
        colGroup === null || colGroup === void 0 ? void 0 : colGroup.forEach(function (col) {
          var colWidth = +col.getAttribute('width');
          var newColWidth = Math.floor(colWidth * articleWidth / tableWidth);
          col.setAttribute('width', String(newColWidth));
        });
      }
    });
    if (articleContentTrackingData) {
      var _ref$current9, _ref$current9$parentE, _ref$current10, _ref$current10$queryS;
      elementScrollTrackManage.addTrack(ref.current, _elementScrollTrack.ScrollType.Vertical, {
        containerElement: (_ref$current9 = ref.current) === null || _ref$current9 === void 0 ? void 0 : (_ref$current9$parentE = _ref$current9.parentElement) === null || _ref$current9$parentE === void 0 ? void 0 : _ref$current9$parentE.parentElement,
        scrollCallback: updateArticleScrolls,
        trackScrollToEnd: true,
        scrollToEndCallBack: function scrollToEndCallBack() {
          return changeTrackCloseArticleContentData === null || changeTrackCloseArticleContentData === void 0 ? void 0 : changeTrackCloseArticleContentData({
            articleScrollToEnd: true
          });
        }
      });
      (_ref$current10 = ref.current) === null || _ref$current10 === void 0 ? void 0 : (_ref$current10$queryS = _ref$current10.querySelectorAll('accordion-block')) === null || _ref$current10$queryS === void 0 ? void 0 : _ref$current10$queryS.forEach(function (ele) {
        var trackingData = {
          trackingsection: _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL],
          trackingtarget: _constants.TRACKING_TARGET.accordionCardTitle,
          trackingdataBasic: _objectSpread({}, articleContentTrackingData)
        };
        ele.setAttribute('tracking', JSON.stringify(trackingData));
      });
    }
    if (richTextMsgTrackingData) {
      var _ref$current11, _ref$current11$parent, _ref$current12, _ref$current12$queryS;
      elementScrollTrackManage.addTrack(ref.current, _elementScrollTrack.ScrollType.Vertical, {
        containerElement: (_ref$current11 = ref.current) === null || _ref$current11 === void 0 ? void 0 : (_ref$current11$parent = _ref$current11.parentElement) === null || _ref$current11$parent === void 0 ? void 0 : _ref$current11$parent.parentElement,
        scrollCallback: updateArticleScrolls,
        trackScrollToEnd: true,
        scrollToEndCallBack: function scrollToEndCallBack() {
          return changeTrackCloseArticleContentData === null || changeTrackCloseArticleContentData === void 0 ? void 0 : changeTrackCloseArticleContentData({
            articleScrollToEnd: true
          });
        }
      });
      (_ref$current12 = ref.current) === null || _ref$current12 === void 0 ? void 0 : (_ref$current12$queryS = _ref$current12.querySelectorAll('accordion-block')) === null || _ref$current12$queryS === void 0 ? void 0 : _ref$current12$queryS.forEach(function (ele) {
        var trackingData = {
          trackingsection: _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL],
          trackingtarget: _constants.TRACKING_TARGET.accordionCardTitle,
          trackingdataBasic: _objectSpread({}, richTextMsgTrackingData)
        };
        ele.setAttribute('tracking', JSON.stringify(trackingData));
      });
    }
  };
  var handleRemoveEventListener = function handleRemoveEventListener() {
    var _ref$current13, _ref$current13$queryS, _ref$current14, _ref$current14$queryS, _ref$current15, _ref$current15$queryS, _ref$current16, _ref$current16$queryS, _ref$current17, _ref$current17$queryS;
    ref === null || ref === void 0 ? void 0 : (_ref$current13 = ref.current) === null || _ref$current13 === void 0 ? void 0 : (_ref$current13$queryS = _ref$current13.querySelectorAll('a')) === null || _ref$current13$queryS === void 0 ? void 0 : _ref$current13$queryS.forEach(function (ele) {
      articleContentTrackingData && removeTrackImpression(ele);
      richTextMsgTrackingData && removeTrackImpression(ele);
      ele.removeEventListener('click', onClickEvent);
    });
    ref === null || ref === void 0 ? void 0 : (_ref$current14 = ref.current) === null || _ref$current14 === void 0 ? void 0 : (_ref$current14$queryS = _ref$current14.querySelectorAll(imgCssSelector)) === null || _ref$current14$queryS === void 0 ? void 0 : _ref$current14$queryS.forEach(function (ele) {
      articleContentTrackingData && removeTrackImpression(ele);
      richTextMsgTrackingData && removeTrackImpression(ele);
      ele.removeEventListener('click', onImageClickEvent);
    });
    ref === null || ref === void 0 ? void 0 : (_ref$current15 = ref.current) === null || _ref$current15 === void 0 ? void 0 : (_ref$current15$queryS = _ref$current15.querySelectorAll(".".concat(DATE_VARIABLE_CONTAINER_CLASS))) === null || _ref$current15$queryS === void 0 ? void 0 : _ref$current15$queryS.forEach(function (ele, index) {
      var _ele$firstElementChil3, _ele$lastElementChild3;
      (_ele$firstElementChil3 = ele.firstElementChild) === null || _ele$firstElementChil3 === void 0 ? void 0 : _ele$firstElementChil3.removeEventListener('mouseover', variableMouseOverListners[variableFormaterType.Date][index]);
      (_ele$lastElementChild3 = ele.lastElementChild) === null || _ele$lastElementChild3 === void 0 ? void 0 : _ele$lastElementChild3.removeEventListener('mouseout', variableMouseOutListners[variableFormaterType.Date][index]);
    });
    ref === null || ref === void 0 ? void 0 : (_ref$current16 = ref.current) === null || _ref$current16 === void 0 ? void 0 : (_ref$current16$queryS = _ref$current16.querySelectorAll(".".concat(STRING_VARIABLE_CONTAINER_CLASS))) === null || _ref$current16$queryS === void 0 ? void 0 : _ref$current16$queryS.forEach(function (ele, index) {
      var _ele$firstElementChil4, _ele$lastElementChild4;
      (_ele$firstElementChil4 = ele.firstElementChild) === null || _ele$firstElementChil4 === void 0 ? void 0 : _ele$firstElementChil4.removeEventListener('mouseover', variableMouseOverListners[variableFormaterType.String][index]);
      (_ele$lastElementChild4 = ele.lastElementChild) === null || _ele$lastElementChild4 === void 0 ? void 0 : _ele$lastElementChild4.removeEventListener('mouseout', variableMouseOutListners[variableFormaterType.String][index]);
    });
    ref === null || ref === void 0 ? void 0 : (_ref$current17 = ref.current) === null || _ref$current17 === void 0 ? void 0 : (_ref$current17$queryS = _ref$current17.querySelectorAll('.redirection-button-to-taskbots-or-app-page')) === null || _ref$current17$queryS === void 0 ? void 0 : _ref$current17$queryS.forEach(function (ele) {
      articleContentTrackingData && removeTrackImpression(ele);
      richTextMsgTrackingData && removeTrackImpression(ele);
      ele.removeEventListener('click', onRedirectionButtonClick);
    });
    articleContentTrackingData && elementScrollTrackManage.removeAllTrack();
    richTextMsgTrackingData && elementScrollTrackManage.removeAllTrack();
  };
  var handleImageError = props.onImageError || function () {};
  var handleImageLoad = props.onImageLoad || function () {};
  var addImageErrorListener = function addImageErrorListener() {
    var _ref$current18, _ref$current18$addEve, _ref$current19, _ref$current19$addEve;
    ref === null || ref === void 0 ? void 0 : (_ref$current18 = ref.current) === null || _ref$current18 === void 0 ? void 0 : (_ref$current18$addEve = _ref$current18.addEventListener) === null || _ref$current18$addEve === void 0 ? void 0 : _ref$current18$addEve.call(_ref$current18, 'error', handleImageError, true);
    ref === null || ref === void 0 ? void 0 : (_ref$current19 = ref.current) === null || _ref$current19 === void 0 ? void 0 : (_ref$current19$addEve = _ref$current19.addEventListener) === null || _ref$current19$addEve === void 0 ? void 0 : _ref$current19$addEve.call(_ref$current19, 'load', handleImageLoad, true);
  };
  var removeImageErrorListener = function removeImageErrorListener() {
    var _ref$current20, _ref$current20$remove, _ref$current21, _ref$current21$remove;
    ref === null || ref === void 0 ? void 0 : (_ref$current20 = ref.current) === null || _ref$current20 === void 0 ? void 0 : (_ref$current20$remove = _ref$current20.removeEventListener) === null || _ref$current20$remove === void 0 ? void 0 : _ref$current20$remove.call(_ref$current20, 'error', handleImageError, true);
    ref === null || ref === void 0 ? void 0 : (_ref$current21 = ref.current) === null || _ref$current21 === void 0 ? void 0 : (_ref$current21$remove = _ref$current21.removeEventListener) === null || _ref$current21$remove === void 0 ? void 0 : _ref$current21$remove.call(_ref$current21, 'load', handleImageLoad, true);
  };
  var handleDisableJumpLink = function handleDisableJumpLink() {
    if (disableSpecialLink) {
      var _ref$current22, _ref$current22$queryS;
      ref === null || ref === void 0 ? void 0 : (_ref$current22 = ref.current) === null || _ref$current22 === void 0 ? void 0 : (_ref$current22$queryS = _ref$current22.querySelectorAll('a')) === null || _ref$current22$queryS === void 0 ? void 0 : _ref$current22$queryS.forEach(function (ele) {
        var _url$split3;
        var url = ele.href;
        var customDataString = (url === null || url === void 0 ? void 0 : (_url$split3 = url.split('custom-data:')) === null || _url$split3 === void 0 ? void 0 : _url$split3[1]) || '';
        var _decodeChatbotTextDat3 = (0, _tools.decodeChatbotTextData)(customDataString),
          dataType = _decodeChatbotTextDat3['data-type'];
        if (dataType === LINK_DATA_TYPE.jumpNode || dataType === LINK_DATA_TYPE.jumpIntent || dataType === LINK_DATA_TYPE.jumpOrderShortcut) {
          ele.classList.add('disabled');
        }
      });
    }
  };
  var trackClickLinkEvent = function trackClickLinkEvent(e) {
    var _e$currentTarget12;
    if (articleContentTrackingData) {
      var _e$currentTarget8, _e$currentTarget9;
      var trackingsection = articleContentTrackingData.trackingsection,
        restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded18); // @ts-ignore

      var url = e === null || e === void 0 ? void 0 : (_e$currentTarget8 = e.currentTarget) === null || _e$currentTarget8 === void 0 ? void 0 : _e$currentTarget8.href;
      var hyperLinkType = getHyperlinkType(e.target);
      var _isIntentLink = hyperLinkType === _constants.ARTICLE_DETAIL_HYPERLINK_TYPE.INTENT;
      var data = generateClickTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.hyperlink, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
        content: (e === null || e === void 0 ? void 0 : (_e$currentTarget9 = e.currentTarget) === null || _e$currentTarget9 === void 0 ? void 0 : _e$currentTarget9.textContent) || '',
        hyperlink_type: hyperLinkType,
        answer_type: _constants.ARTICLE_DETAIL_ANSWER_TYPE.ARTICLE,
        trigger_type: _isIntentLink ? REDIRECTION_BUTTON_TRIGGER_TYPE.INTENT : REDIRECTION_BUTTON_TRIGGER_TYPE.URL,
        target_link: !_isIntentLink ? url : undefined,
        target_intent_id: _isIntentLink ? Number(getIntentLink(url)) : undefined
      }));
      handleTrackerClick(data);
    }
    if (richTextMsgTrackingData) {
      var _e$currentTarget10;
      var _trackingsection9 = richTextMsgTrackingData.trackingsection,
        _restArticleContentTrackingData9 = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded19);
      var _data4 = generateClickTrackingData(_trackingsection9 || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.hyperlink, _objectSpread(_objectSpread({}, _restArticleContentTrackingData9), {}, {
        content: (e === null || e === void 0 ? void 0 : (_e$currentTarget10 = e.currentTarget) === null || _e$currentTarget10 === void 0 ? void 0 : _e$currentTarget10.textContent) || '',
        hyperlink_type: getHyperlinkType(e.target),
        answer_type: _constants.ARTICLE_DETAIL_ANSWER_TYPE.ARTICLE
      }));
      handleTrackerClick(_data4);
    }
    if (linkTrackingData.hyperlink) {
      var _e$currentTarget11;
      var _data5 = generateClickTrackingData(_constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.hyperlink, _objectSpread(_objectSpread({}, linkTrackingData.hyperlink), {}, {
        content: (e === null || e === void 0 ? void 0 : (_e$currentTarget11 = e.currentTarget) === null || _e$currentTarget11 === void 0 ? void 0 : _e$currentTarget11.textContent) || '',
        hyperlink_type: getHyperlinkType(e.target),
        answer_type: _constants.ARTICLE_DETAIL_ANSWER_TYPE.RICH_TEXT
      }));
      handleTrackerClick(_data5);
    } // @ts-ignore

    var _getJumpLinkData = getJumpLinkData(e === null || e === void 0 ? void 0 : (_e$currentTarget12 = e.currentTarget) === null || _e$currentTarget12 === void 0 ? void 0 : _e$currentTarget12.href),
      dataType = _getJumpLinkData.dataType;
    if (dataType === LINK_DATA_TYPE.jumpIntent && linkTrackingData !== null && linkTrackingData !== void 0 && linkTrackingData.jumpIntent) {
      var _data6 = generateClickTrackingData(_constants.TRACKING_SECTION[_constants.TRACKING_TYPE.JUMP_INTENT], _constants.TRACKING_TARGET.jumpIntent, _objectSpread(_objectSpread({}, linkTrackingData === null || linkTrackingData === void 0 ? void 0 : linkTrackingData.jumpIntent), {}, {
        is_change_order_option: msgType === _Message.MsgType.changeOrder ? 1 : 0
      }));
      handleTrackerClick(_data6);
    }
  };
  var trackLinkImpressionEvent = function trackLinkImpressionEvent(ele) {
    if (articleContentTrackingData) {
      var trackingsection = articleContentTrackingData.trackingsection,
        restArticleContentTrackingData = (0, _objectWithoutProperties2.default)(articleContentTrackingData, _excluded20); // @ts-ignore

      var _url = ele === null || ele === void 0 ? void 0 : ele.href;
      var hyperLinkType = getHyperlinkType(ele);
      var _isIntentLink2 = hyperLinkType === _constants.ARTICLE_DETAIL_HYPERLINK_TYPE.INTENT;
      var impressionTrackingData = generateImpressionTrackingData(trackingsection || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.hyperlink, _objectSpread(_objectSpread({}, restArticleContentTrackingData), {}, {
        content: ele.textContent || '',
        hyperlink_type: getHyperlinkType(ele),
        answer_type: _constants.ARTICLE_DETAIL_ANSWER_TYPE.ARTICLE,
        trigger_type: _isIntentLink2 ? REDIRECTION_BUTTON_TRIGGER_TYPE.INTENT : REDIRECTION_BUTTON_TRIGGER_TYPE.URL,
        target_link: !_isIntentLink2 ? _url : undefined,
        target_intent_id: _isIntentLink2 ? Number(getIntentLink(_url)) : undefined
      }));
      handleTrackImpression(ele, impressionTrackingData);
    }
    if (richTextMsgTrackingData) {
      var _trackingsection10 = richTextMsgTrackingData.trackingsection,
        _restArticleContentTrackingData10 = (0, _objectWithoutProperties2.default)(richTextMsgTrackingData, _excluded21);
      var _impressionTrackingData6 = generateImpressionTrackingData(_trackingsection10 || _constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.hyperlink, _objectSpread(_objectSpread({}, _restArticleContentTrackingData10), {}, {
        content: ele.textContent || '',
        hyperlink_type: getHyperlinkType(ele),
        answer_type: _constants.ARTICLE_DETAIL_ANSWER_TYPE.ARTICLE
      }));
      handleTrackImpression(ele, _impressionTrackingData6);
    }
    if (linkTrackingData.hyperlink) {
      var _impressionTrackingData7 = generateImpressionTrackingData(_constants.TRACKING_SECTION[_constants.TRACKING_TYPE.ARTICLE_DETAIL], _constants.TRACKING_TARGET.hyperlink, _objectSpread(_objectSpread({}, linkTrackingData.hyperlink), {}, {
        content: ele.textContent || '',
        hyperlink_type: getHyperlinkType(ele),
        answer_type: _constants.ARTICLE_DETAIL_ANSWER_TYPE.RICH_TEXT
      }));
      handleTrackImpression(ele, _impressionTrackingData7);
    }
    var url = ele === null || ele === void 0 ? void 0 : ele.href;
    var _getJumpLinkData2 = getJumpLinkData(url),
      dataType = _getJumpLinkData2.dataType;
    if (dataType === LINK_DATA_TYPE.jumpIntent && linkTrackingData !== null && linkTrackingData !== void 0 && linkTrackingData.jumpIntent) {
      var data = generateImpressionTrackingData(_constants.TRACKING_SECTION[_constants.TRACKING_TYPE.JUMP_INTENT], _constants.TRACKING_TARGET.jumpIntent, _objectSpread(_objectSpread({}, linkTrackingData === null || linkTrackingData === void 0 ? void 0 : linkTrackingData.jumpIntent), {}, {
        is_change_order_option: msgType === _Message.MsgType.changeOrder ? 1 : 0
      }));
      handleTrackImpression(ele, data);
    }
  };
  var addExpandIcon = function addExpandIcon() {
    var _ref$current23, _ref$current23$queryS;
    ref === null || ref === void 0 ? void 0 : (_ref$current23 = ref.current) === null || _ref$current23 === void 0 ? void 0 : (_ref$current23$queryS = _ref$current23.querySelectorAll(imgCssSelector)) === null || _ref$current23$queryS === void 0 ? void 0 : _ref$current23$queryS.forEach(function (ele) {
      var expendIcon = document.createElement('img');
      expendIcon.src = _expand.default;
      expendIcon.className = 'expend-icon';
      var imgContainer = document.createElement('div');
      imgContainer.className = 'expend-icon-container';
      imgContainer.appendChild(ele.cloneNode());
      imgContainer.appendChild(expendIcon);
      var parentElement = ele.parentElement;
      parentElement === null || parentElement === void 0 ? void 0 : parentElement.removeChild(ele);
      parentElement === null || parentElement === void 0 ? void 0 : parentElement.appendChild(imgContainer);
    });
  };
  (0, _react.useEffect)(function () {
    var _props$changeTrackClo;
    (_props$changeTrackClo = props.changeTrackCloseArticleContentData) === null || _props$changeTrackClo === void 0 ? void 0 : _props$changeTrackClo.call(props, {
      startTime: new Date()
    });
  }, []);
  (0, _react.useEffect)(function () {
    // 根据 内容变化 重新对 dom 进行绑定等处理
    if (showExpandIcon) {
      addExpandIcon();
    }
    addImageErrorListener();
    handleAddEventListener();
    handleDisableJumpLink();
    return function () {
      handleRemoveEventListener();
      removeImageErrorListener();
    };
  }, [html]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('rich-text'), (_clsx = {}, (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('rich-text-ui-optimisation-button'), isUIOptimisationButton), (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('rich-text-ui-optimisation-table-modal'), isUIOptimisationTableModal), (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('rich-text-ui-optimisation-table-review'), isUIOptimisationTableReview), (0, _defineProperty2.default)(_clsx, (0, _getPrefixCls.getPrefixCls)('rich-text-ui-optimisation-table-richtext'), isUIOptimisationTableRichtext), _clsx), className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    dangerouslySetInnerHTML: html,
    className: msgType === _Message.MsgType.changeOrder ? (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('rich-text-changeorder')) : (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('rich-text-content'), (0, _getPrefixCls.getPrefixCls)('rich-text-container'), {
      'th-strong': region === 'th'
    })
  }));
};
exports.RichText = RichText;